export default "__VITE_ASSET__uppN44Va__"